/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable max-len */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import settingsProps from './prop-types/settingsProps';
import Message from './Message';

/**
 * An alert banner.
 */
const Banner = ({
  triggerCollapse,
  moreAlertText,
  isFirst,
  message,
  settings,
  type,
  url,
  position,
}) => {
  const typeWithDashes = type.toLowerCase().replace(' ', '-');

  const {
    label,
  } = settings;

  /**
   * Set up the banner classes.
   *
   * @type {string}
   */
  const rootClasses = clsx(
    'alert-banner',
    `alert-banner--${typeWithDashes}`,
  );

  /**
   * Toggle document body classes.
   */
  useEffect(() => {
    const bodyClass = [
      'has-active-alert-banners',
      `has-active-alert-banners--${typeWithDashes}`,
    ];
    document.body.classList.add(...bodyClass);
    return () => document.body.classList.remove(...bodyClass);
  }, []);

  return (
    <div className={rootClasses}>
      <div className="alert-banner__inner-wrapper">
        <div className="alert-banner__inner">
          <div className="alert-banner__messages-wrapper">
            <Message
              triggerCollapse={triggerCollapse}
              isFirst={isFirst}
              moreAlertText={moreAlertText}
              content={message}
              label={label}
              url={url}
              position={position}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

Banner.propTypes = {
  triggerCollapse: PropTypes.func,
  moreAlertText: PropTypes.string,
  isFirst: PropTypes.bool,
  message: PropTypes.string.isRequired,
  settings: PropTypes.shape(settingsProps).isRequired,
  type: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  position: PropTypes.number,
};

Banner.defaultProps = {
  triggerCollapse: () => {},
  moreAlertText: '',
  isFirst: false,
  position: 1,
};

export default Banner;
